import { Construction } from "lucide-react";

export interface ComingSoonProps {
  title?: string;
}

export function ComingSoon({ title = "This feature" }: ComingSoonProps) {
  return (
    <div className="flex h-full min-h-[480px] flex-1 flex-col items-center justify-center gap-3 px-6 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-cyan-50">
        <Construction className="h-7 w-7 text-cyan-600" />
      </div>
      <h2 className="text-lg font-semibold text-slate-900">{title} is coming soon</h2>
      <p className="max-w-sm text-sm text-slate-500">
        We&apos;re still working on this page. Check back soon.
      </p>
    </div>
  );
}